import { render } from "./BankAccounts.vue?vue&type=template&id=154752b0&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"

import "./BankAccounts.vue?vue&type=style&index=0&id=154752b0&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154752b0"]])

export default __exports__